import _ from 'underscore'

export function getSelectedOptions (answers, getOptionsByAnswer) {
  let selectedOptions = []
  _.each(answers, (answer) => {
    let foundOptions = getOptionsByAnswer(answer)
    _.each(foundOptions, (foundOption) => {
      if (Array.isArray(answer.value)) {
        _.each(answer.value, (answerValue) => {
          if (foundOption.option_value === answerValue) {
            selectedOptions.push(foundOption)
          }
        })
      } else {
        if (foundOption.option_value === answer.value) {
          selectedOptions.push(foundOption)
        }
      }
    })
  })

  return selectedOptions
}

export function getFailedValidationQuestions (currentQuestions, getAnswers, possibleFunctionNames) {
  let wrongAnsweredQuestions = []

  _.each(currentQuestions, (currentQuestion) => {
    let answer = _.find(getAnswers, (answer) => {
      return +currentQuestion.id === +answer.question_id
    })

    // validate required fields
    if (+currentQuestion.field_required === 1 || currentQuestion.field_required === true) {
      if (typeof answer === 'undefined' || answer.value === '' || answer.value.length === 0) {
        wrongAnsweredQuestions.push(currentQuestion)
        return
      }
    }

    // validate number fields
    if (currentQuestion.field_type === 'number') {
      if (typeof answer !== 'undefined' && answer.value !== '' && !isNumeric(answer.value)) {
        wrongAnsweredQuestions.push(currentQuestion)
        return
      }
    }

    if (currentQuestion.type === 'function_name' && answer.value !== '') {
      if (possibleFunctionNames.indexOf(answer.value.toLowerCase()) === -1) {
        wrongAnsweredQuestions.push(currentQuestion)
      }
    }

  })

  return wrongAnsweredQuestions
}

export function isNumeric (n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}